import { ExternalConnectionLink } from "../api/externalConnections";


export const isExternalConnectionLinkJudiCare = (link: ExternalConnectionLink) => {
  return ["judi health preview", "judi health", "judi care preview", "judi care"].includes(link.label.toLowerCase());
};
